import { QcsDropdownItem } from '../../common/basic/QcsDropdownMenu';
import { TFunction } from 'i18next';
import { GROUP_SUBHEADER_KEYS, GroupByOption } from '../analyticsDomainConfig';

export const buildGroupByDropdownItems = (
  options: GroupByOption[],
  t: TFunction,
): QcsDropdownItem<string>[] =>
  options.flatMap<QcsDropdownItem<string>>((opt, idx) => [
    ...(opt.group && opt.group !== options[idx - 1]?.group
      ? [
          {
            isSubheader: true as const,
            key: `subheader-${opt.group}`,
            label: t(GROUP_SUBHEADER_KEYS[opt.group]),
          },
        ]
      : []),
    {
      key: opt.value,
      value: opt.value,
      label: t(opt.labelKey),
      grouped: !!opt.group,
    },
  ]);
